import { render, staticRenderFns } from "./RecordWindow.vue?vue&type=template&id=62631daa&"
import script from "./RecordWindow.vue?vue&type=script&lang=js&"
export * from "./RecordWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports